// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__3a178","pink":"button_pink__1w12G","darkpink":"button_darkpink__2AmDr"};